import React from "react";

import AccountsListItem from "./accountsListItem";
import { StyledAccountsList } from "./styled";
import * as Types from "./types";

const AccountsList: React.FC<Types.AccountsList> = ({ businessAccounts, onAccountSelected }) => (
  <StyledAccountsList>
    {businessAccounts &&
      businessAccounts.map((businessAccount) => (
        <AccountsListItem
          key={businessAccount.id}
          businessAccount={businessAccount}
          onClick={() => onAccountSelected(businessAccount)}
        />
      ))}
  </StyledAccountsList>
);

export default AccountsList;
